import { Route } from '@angular/router';
import { Path } from '../../common/constants/paths.constant';
import { authGuard, notAuthGuard } from '../../common/guards/auth.guard';
import { userStateGuard } from '../../common/guards/userState.guard';
import { signupStorageGuard } from '../../common/guards/signup-storage.guard';
import { otpStorageGuard } from '../../common/guards/otp-storage.guard';
import { passwordResetStorageGuard } from '../../common/guards/password-reset-storage.guard';

export const mainRoutes: Route[] = [
  {
    path: Path.SIGN_UP_ACCOUNT_INFO,
    loadComponent: () =>
      import('../../pages/main/auth/signup-account-info/signup-account-info.component').then(
        c => c.SignupAccountInfoComponent
      ),
    canActivate: [notAuthGuard],
  },
  {
    path: Path.SIGN_PASSWORD,
    loadComponent: () =>
      import('../../pages/main/auth/signup-password/signup-password.component').then(
        c => c.SignupPasswordComponent
      ),
    canActivate: [notAuthGuard, signupStorageGuard],
  },
  {
    path: Path.OTP,
    loadComponent: () =>
      import('./auth/otp/otp.component').then(c => c.OtpComponent),
    canActivate: [notAuthGuard, otpStorageGuard],
  },
  {
    path: Path.LOGIN,
    loadComponent: () =>
      import('../../pages/main/auth/login/login.component').then(
        c => c.LoginComponent
      ),
    canActivate: [notAuthGuard],
  },
  {
    path: Path.RESET_PASSWORD_REQUEST,
    loadComponent: () =>
      import('../../pages/main/auth/reset-password-request/reset-password-request.component').then(
        c => c.ResetPasswordRequestComponent
      ),
    canActivate: [notAuthGuard],
  },
  {
    path: Path.RESET_PASSWORD,
    loadComponent: () =>
      import('../../pages/main/auth/reset-password/reset-password.component').then(
        c => c.ResetPasswordComponent
      ),
    canActivate: [notAuthGuard, passwordResetStorageGuard],
  },
  {
    path: Path.PASSWORD_CHANGE_SUCCESS,
    loadComponent: () =>
      import('../../pages/main/auth/password-change-success/password-change-success.component').then(
        c => c.PasswordChangeSuccessComponent
      ),
    canActivate: [notAuthGuard],
  },
  {
    path: Path.WELCOME_TO_CONTRAA,
    loadComponent: () =>
      import('./user/user-type-select/user-type-select.component').then(
        c => c.UserTypeSelectComponent
      ),
    canActivate: [authGuard, userStateGuard],
  },
  {
    path: Path.SUPPLIER_REGISTRATION,
    loadComponent: () =>
      import('../../pages/main/user/supplier-register/supplier-register.component').then(
        c => c.SupplierRegisterComponent
      ),
    canActivate: [authGuard, userStateGuard],
  },
  {
    path: Path.BUYER_REGISTRATION,
    loadComponent: () =>
      import('../../pages/main/user/buyer-register/buyer-register.component').then(
        c => c.BuyerRegisterComponent
      ),
    canActivate: [authGuard, userStateGuard],
  },
  {
    path: Path.CONTRACTOR_REGISTRATION,
    loadComponent: () =>
      import('../../pages/main/user/contractor-register/contractor-register.component').then(
        c => c.ContractorRegisterComponent
      ),
    canActivate: [authGuard, userStateGuard],
  },
];
